import {XHTTP} from '@/shared/xhttp';
import {OrganisationService} from "@/xhttp/OrganisationService";
import {Client} from "@/models/Client";
import {Tache} from "@/models/Tache";
import {Projet} from "@/models/Projet";
import {User} from "@/models/User";
import {DateHelper} from "@/shared/utils";

@XHTTP(OrganisationService, '/organisations')
export class Organisation {

	private _id: number;
	private _name: string;
	private _address: string;
	private _zipCode: string;
	private _town: string;
	private _country: string;
	private _phone: string;
	private _fax: string;
	private _email: string;
	private _website: string;
	private _logo: string;
	private _ceo: string;
	private _capital: number;
	private _legalEntity: string;
	private _siren: string;
	private _siret: string;
	private _nafApe: string;
	private _rcsRm: string;
	private _tvaNumber: string;
	private _createdAt: Date;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get name(): string {
		return this._name;
	}

	public get address(): string {
		return this._address;
	}

	public get zipCode(): string {
		return this._zipCode;
	}

	public get town(): string {
		return this._town;
	}

	public get country(): string {
		return this._country;
	}

	public get phone(): string {
		return this._phone;
	}

	public get fax(): string {
		return this._fax;
	}

	public get email(): string {
		return this._email;
	}

	public get website(): string {
		return this._website;
	}

	public get logo(): string {
		return this._logo;
	}

	public get ceo(): string {
		return this._ceo;
	}

	public get capital(): number {
		return this._capital;
	}

	public get legalEntity(): string {
		return this._legalEntity;
	}

	public get siren(): string {
		return this._siren;
	}

	public get siret(): string {
		return this._siret;
	}

	public get nafApe(): string {
		return this._nafApe;
	}

	public get rcsRm(): string {
		return this._rcsRm;
	}

	public get tvaNumber(): string {
		return this._tvaNumber;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	/////////////
	// Setters //
	/////////////

	public set id(value: number) {
		this._id = value;
	}

	public set name(value: string) {
		this._name = value;
	}

	public set address(value: string) {
		this._address = value;
	}

	public set zipCode(value: string) {
		this._zipCode = value;
	}

	public set town(value: string) {
		this._town = value;
	}

	public set country(value: string) {
		this._country = value;
	}

	public set phone(value: string) {
		this._phone = value;
	}

	public set fax(value: string) {
		this._fax = value;
	}

	public set email(value: string) {
		this._email = value;
	}

	public set website(value: string) {
		this._website = value;
	}

	public set logo(value: string) {
		this._logo = value;
	}

	public set ceo(value: string) {
		this._ceo = value;
	}

	public set capital(value: number) {
		this._capital = value;
	}

	public set legalEntity(value: string) {
		this._legalEntity = value;
	}

	public set siren(value: string) {
		this._siren = value;
	}

	public set siret(value: string) {
		this._siret = value;
	}

	public set nafApe(value: string) {
		this._nafApe = value;
	}

	public set rcsRm(value: string) {
		this._rcsRm = value;
	}

	public set tvaNumber(value: string) {
		this._tvaNumber = value;
	}

	///////////////
	// Serialize //
	///////////////+

	public toJSON(): any {
		return {
			id       : this._id,
			name     : this._name,
			address     : this._address,
			zipCode     : this._zipCode,
			town     : this._town,
			country     : this._country,
			phone     : this._phone,
			fax     : this._fax,
			email     : this._email,
			website     : this._website,
			logo     : this._logo,
			ceo     : this._ceo,
			capital  : this._capital,
			legalEntity     : this._legalEntity,
			siren     : this._siren,
			siret     : this._siret,
			nafApe     : this._nafApe,
			rcsRm     : this._rcsRm,
			tvaNumber     : this._tvaNumber,
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._name      = data.name;
		this._address      = data.address;
		this._zipCode      = data.zipCode;
		this._town      = data.town;
		this._country      = data.country;
		this._phone      = data.phone;
		this._fax      = data.fax;
		this._email      = data.email;
		this._website      = data.website;
		this._logo      = data.logo;
		this._ceo      = data.ceo;
		this._capital   = data.capital;
		this._legalEntity      = data.legalEntity;
		this._siren      = data.siren;
		this._siret      = data.siret;
		this._nafApe      = data.nafApe;
		this._rcsRm      = data.rcsRm;
		this._tvaNumber      = data.tvaNumber;
		this._createdAt                  = data.createdAt ? new Date(data.createdAt) : null;
		return this;
	}
}